export const TSLAddressLink =
  '  https://www.google.com/maps/place/The+SilverLogic/@26.4034994,-80.1064823,17z/data=!3m2!4b1!5s0x88d91e2c889eb085:0x4c108f0111a33c53!4m5!3m4!1s0x88d8e1dff449eab7:0xe3b8582075db660c!8m2!3d26.4034946!4d-80.1042883'
